module.exports = __webpack_public_path__ + "static/media/Desktop_HomeSearchList.01e49208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haf/Desktop_HomeSearchList.png
// module id = 82
// module chunks = 0